/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CandidateEmailStorePathParams,
	CandidateEmailStoreRequest,
	CandidateEmailStoreResponse,
} from '../types/CandidateEmailStore'

/**
 * POST /candidates/:candidateId/emails
 * @see backend/nexus/modules/Campaign/Http/Controllers/CandidateEmailController.php CandidateEmailController::store
 */
export async function candidateEmailStore(
	candidateId: CandidateEmailStorePathParams['candidateId'],
	data: CandidateEmailStoreRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidateEmailStoreResponse>> {
	return axiosInstance.post(`/candidates/${candidateId}/emails`, data, config)
}
